import Marquee from "react-fast-marquee";

const ITEMS = [
  "BUY 4 CAR TYRES",
  "FREE INFLATOR WORTH ₹4,000",
  "₹2,000 AMAZON VOUCHER",
  "10 PREMIUM BRANDS",
  "5 STORES · BENGALURU",
];

export default function MarqueeStrip() {
  return (
    <div
      data-testid="offer-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#0a0a0a] py-6"
      aria-hidden
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item, i) => (
          <span key={item} className="flex items-center">
            <span
              className={`font-display text-3xl uppercase tracking-wide md:text-4xl ${
                i % 2 === 0 ? "text-outline" : "text-[#FF3B30]"
              }`}
            >
              {item}
            </span>
            <span className="mx-12 block h-3 w-3 rotate-45 bg-[#FFCC00]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
